import { render } from "./ConfigFacturas.vue?vue&type=template&id=9eba6ac6&scoped=true"
import script from "./ConfigFacturas.vue?vue&type=script&lang=ts"
export * from "./ConfigFacturas.vue?vue&type=script&lang=ts"

import "./ConfigFacturas.vue?vue&type=style&index=0&id=9eba6ac6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9eba6ac6"

export default script